import isArray from 'lodash/isArray';
import isObjectLike from 'lodash/isObjectLike';

const MAX_DEPTH = 50;

function _flattenObject(ob: object, currentDepth: number, includeParentKey = true) {
  const toReturn = {};

  if (currentDepth > MAX_DEPTH) throw new Error(`Reacted max recursive depth for flattenObject`);

  for (const prop in ob) {
    if (!ob.hasOwnProperty(prop)) continue;

    if (isObjectLike(ob[prop]) && !isArray(ob[prop])) {
      const flatObject = _flattenObject(ob[prop], currentDepth + 1, includeParentKey);
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        if (includeParentKey) {
          toReturn[`${prop}.${x}`] = flatObject[x];
        } else {
          toReturn[`${x}`] = flatObject[x];
        }
      }
    } else {
      toReturn[prop] = ob[prop];
    }
  }

  return toReturn;
}

/**
 * Flattens an object into a single-depth object.
 * Example:
 *   flattenObject({ animal: { name: "bob", breed: { name: "fox" }} } }) => { "animal.name": "bob", "animal.breed.name": "fox" }
 */
export const flattenObject = (ob: object, includeParentKey = true) => _flattenObject(ob, 0, includeParentKey);

export function isTypeByKey<T extends object>(maybe: any, key: keyof T): maybe is T {
  return maybe instanceof Object && maybe[key];
}

export const isEmptyObject = (object: object) => {
  try {
    return JSON.stringify(object) === '{}';
  } catch {
    return false;
  }
};

export const getObjectKeyLength = (object: Record<string, unknown> | object) => Object.keys(object).length;
